import { render, staticRenderFns } from "./Policymodel.vue?vue&type=template&id=b6b1c016"
import script from "./Policymodel.vue?vue&type=script&lang=js"
export * from "./Policymodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports